module.exports = __webpack_public_path__ + "static/media/activityIntro4.7def89dd.png";